import { SupportedSearchParam } from "@utils/types";

const getLowercaseKeyUrlSearchParams = (urlSearchParams: URLSearchParams): URLSearchParams => {
  const lowerCaseEntries = Array.from(urlSearchParams.entries()).map(([key, value]) => [key.toLowerCase(), value]);
  return new URLSearchParams(lowerCaseEntries);
};

export const getSupportedSearchParamFromUrl = (supportedSearchParam: SupportedSearchParam): string | null => {
  const searchParams = new URLSearchParams(window.location.search);
  const params = getLowercaseKeyUrlSearchParams(searchParams);
  return params.get(supportedSearchParam);
};
